import { render, staticRenderFns } from "./TotalAmount.vue?vue&type=template&id=31526be3"
import script from "./TotalAmount.vue?vue&type=script&lang=js"
export * from "./TotalAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports